import { connect } from 'react-redux';
import AfterAction from '../../../components/event/after-action';
import {
    updateAfterAction,
    rejectAfterAction,
    approveAfterAction,
    requestInfoAfterAction,
    updateAndSubmitAfterAction,
    setEventErrorMessage,
    setEventUserAction,
    clearAllErrors,
    createAANoteThunk,
    setEventSuccessMessage
} from '../../../actions';

import {
    getEventActions,
    getEventStatus,
    getEventActionLoading,
    getEventActionText,
    getEventForm
} from '../../../reducers';

const mapStateToProps = state => ({
    eventActions: getEventActions(state),
    status: getEventStatus(state),
    eventActionText: getEventActionText(state),
    eventActionLoading: getEventActionLoading(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasAfterActionActions,
    successMessage: state.events.successMessage,
    errorMessage: state.events.errorMessage,
    userIsCreator: state.events.userIsCreator,
    userAction: state.events.userAction,
    eventName: state.events.name,
    prAccessible: state.events.prAccessible,
    tasks: state.events.aaTasks,
    requestMessage: state.events.aaRequestMessage,
    startDate: state.events.startDate,
    jwtToken: state.auth.jwtToken,
    eventId: state.events.id,
    afterActionUserID: state.event.EventReport.userId,
    groupStatus: state.events.groupStatus,
    eventState: state.event,
    eventForm: getEventForm(state)
});

const mapDispatchToProps = dispatch => ({
    updateAfterAction: data => dispatch(updateAfterAction(data)),
    rejectAfterAction: data => dispatch(rejectAfterAction(data)),
    approveAfterAction: data => dispatch(approveAfterAction(data)),
    requestInfoAfterAction: data => dispatch(requestInfoAfterAction(data)),
    submitAfterAction: data => dispatch(updateAndSubmitAfterAction(data)),
    setEventErrorMessage: bool => dispatch(setEventErrorMessage(bool)),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    clearAllErrors: () => dispatch(clearAllErrors()),
    createNote: e => dispatch(createAANoteThunk(e)),
    clearMessage: () => dispatch(setEventSuccessMessage(null))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AfterAction);



// WEBPACK FOOTER //
// ./src/containers/event/after-action/index.js